import * as types from "../constants/actionTypes";

export const searchLocationsInitialState = {
    locations: [],
    totalLocations: 0,
    //equipment: [],
    locationType: '',
    perks: '',
    services: '',
    specialties: '',
    success: false,
    searchRunning: false,
    error: false,
    updateFacets: false,
    searchModel: null
};

export default function searchLocationsReducer(state = searchLocationsInitialState, action) {
    switch (action.type) {

        case types.UPDATE_FACETS:
            return { ...state, updateFacets: action.updateFacets };

        case types.CLEAR_LOCATIONS:
            return { searchLocationsInitialState };

        case types.CLEAR_LOCATIONS_RESULTS:
            return { ...state, locations: [], totalLocations: 0, locationType: '', perks: '', services: '', specialties: '' };

        case types.SEARCH_LOCATION_CLEAR:
            return { ...state, success: false, locations: [], totalLocations: 0 };
        case types.SEARCH_LOCATION:
            return { ...state, searchModel: action.searchModel, success: true, searchRunning: true, error: false };
        case types.SEARCH_LOCATION_SUCCESS:
            // api returned an http 200 with a null response body.
            if (action === null || action.locations === null) {
                return {
                    ...state,
                    locations: [],
                    totalLocations: 0,
                    //equipment: [],
                    locationType: '',
                    perks: '',
                    services: '',
                    specialties: '',
                    success: false,
                    searchRunning: false,
                    error: true
                };
            }
            else {
                // successful response.
                return {
                    ...state,
                    locations: action.locations.locationResults,
                    totalLocations: action.locations.locationCount,
                    locationType: action.locations.aggregations && action.locations.aggregations.locationtypefacet,
                    perks: action.locations.aggregations && action.locations.aggregations.perksfacet,
                    services:  action.locations.aggregations && action.locations.aggregations.servicesandequipmentfacet,
                    specialties: action.locations.aggregations && action.locations.aggregations.specialtiesfacet,
                    success: true,
                    searchRunning: false,
                    error: false,
                    updateFacets: false,
                    appliedRules: action && action.locations && action.locations.appliedRules ? action.locations.appliedRules : []
                };
            }
        case types.SEARCH_LOCATION_ERROR:
            return { ...state, success: false, searchRunning: false, error: true };
        case types.GET_LOCATION_TYPES_SUCCESS:
            return { ...state, locationTypes: action.locTypes, success: true, searchRunning: false, error: false };
        case types.GEOLOCATION:
            return { ...state, waitingOnGeolocation: true, latitude: null, longitude: null, geolocationError: "" }; //Task 34261,  reset lat & lng also as it is causing update issues in UI.
        case types.GEOLOCATION_SUCCESS:
            return { ...state, latitude: action.latitude, longitude: action.longitude, waitingOnGeolocation: false, geolocationError: "", isCurrentLocation: action.isCurrentLocation };
        case types.GEOLOCATION_FAILURE:
            return { ...state, waitingOnGeolocation: false, latitude: null, longitude: null, geolocationError: action.geolocationError, isCurrentLocation: action.isCurrentLocation };
        case types.GEOADDRESS:
            return { ...state, waitingOnGeoAddress: true, geolocationError: "" }; 
        case types.GEOADDRESS_SUCCESS:
            return { ...state, city: action.city, state: action.state, geoAddressError: "", waitingOnGeoAddress: false };
        case types.GEOADDRESS_FAILURE:
            return { ...state, geoAddressError: action.geoAddressError, waitingOnGeoAddress: false };
        case types.LOGOUT:
            return searchLocationsInitialState;
        default:
            return { ...state };
    }
}